export type ReferralSource = {
	label: string,
	value: string,
}

export const referralSourceOptions: ReferralSource[] = [
	{ label: "Google Search", value: "searchEngine" },
	{ label: "Facebook", value: "facebook" },
	{ label: "Instagram", value: "instagram" },
	{ label: "A friend", value: "friend" },
	{ label: "A flyer", value: "flyer" },
	{ label: "Other", value: "other" },
]

export const serviceCounties = [
	'Anderson County, TN',
	'Blount County, TN',
	'Jefferson County, TN',
	'Knox County, TN',
	'Loudon County, TN',
	'Monroe County,TN',
	'Roane County, TN',
	'Sevier County, TN',
]


